<template>
  <div>
    <div id="review-page-vue" class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h2>
              {{ labels[1089] }}
              <!-- Review Order -->
            </h2>
            <input type="hidden" :value="labels[1042] + ' - ' + labels[1089]" id="page-title" />
            <!-- todo: do we need to add a row for quote path to display the quote ID/message? -->
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <h4>
                  {{ labels[1056] }}
                  <!-- Products -->
                  <span class="right">
                    {{ labels[1096] }}
                    <!-- Quantity -->
                  </span>
                </h4>
                <table class="table table-condensed" id="item-summary">
                  <CheckoutReviewItem :item-list="itemListReversed" />
                  <tfoot v-if="!isQuote">
                    <tr>
                      <td colspan="3">
                        <router-link rel="nofollow" class="right edit" :to="{ name: 'Cart' }">
                          {{ labels[1091] }}
                          <!-- Edit -->
                        </router-link>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div class="col-lg-5 col-lg-offset-1 col-md-5 col-md-offset-1 col-sm-5 col-xs-12">
                <div id="review-addpay">
                  <h4>
                    {{ labels[1058] }}
                    <!-- Shipping -->
                  </h4>
                  <div>
                    <table class="table table-condensed table-no-border">
                      <tbody>
                        <tr>
                          <td>
                            {{ labels[1090] }}
                            <!-- Address -->
                            :
                          </td>
                          <td>
                            <div>{{ addresses.shipping.ORGANIZATION }}</div>
                            <div v-html="breakCharsToBr(addresses.shipping.ADDRESS)"></div>
                            <div>
                              {{ addresses.shipping.CITY }}, {{ addresses.shipping.STATE }}
                              {{ addresses.shipping.POSTAL }}
                            </div>
                            <br />
                            <div>
                              <em>{{ labels[1383] }}</em>
                            </div>
                            <!-- label: Attention: -->
                            <div>{{ addresses.shipping.ATTNNAME }}</div>
                            <div
                              v-if="
                                addresses.shipping.ATTNPHONE && addresses.shipping.ATTNPHONE.length
                              "
                            >
                              {{ addresses.shipping.ATTNPHONE }}
                            </div>
                          </td>
                          <td>
                            <router-link
                              rel="nofollow"
                              class="edit"
                              v-if="!isQuote"
                              :to="{ name: 'Ship Address' }"
                            >
                              {{ labels[1091] }}
                              <!-- Edit -->
                            </router-link>
                          </td>
                        </tr>
                        <!-- only shipping type us handles is standardShipping right now -->
                        <!-- <tr v-if="shipping.type == 'noShip'">-- Electronic/Download Only --
                                                    <td>{{ labels[1508] }}-- label: Type: --</td>
                                                    <td>{{ labels[1818] }}-- label: Not Required --</td>
                                                </tr>
                                                <template v-if="shipping.type == 'standardShipping'"> -->
                        <tr>
                          <td>
                            {{ labels[1508] }}
                            <!-- label: Type: -->
                          </td>
                          <td>{{ labels[1472] }}</td>
                          <!-- label: Standard Freight -->
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            {{ labels[1094] }}
                            <!-- Service -->
                            :
                          </td>
                          <td>
                            <template
                              v-if="
                                shipMethod.constructor === Object &&
                                  Object.keys(shipMethod).length != 0
                              "
                            >
                              {{ shipMethod.shipMethod }}
                            </template>
                            <template v-else>
                              {{ labels[1338] }}
                              <!-- label: N/A-->
                            </template>
                          </td>
                          <td>
                            <router-link
                              rel="nofollow"
                              class="edit"
                              v-if="!isQuote"
                              :to="{ name: 'Ship Method' }"
                            >
                              {{ labels[1091] }}
                              <!-- Edit -->
                            </router-link>
                          </td>
                        </tr>
                        <!-- </template>
                                                <template v-if="shipping.type == 'collectShipping'">
                                                    <tr>
                                                        <td>
                                                            {{ labels[1508] }}-- label: Type: --
                                                        </td>
                                                        <td>
                                                            {{ labels[1473] }}-- label: Corporate Shipping Account --
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{ labels[1482] }}:-- label: Freight Company --</td>
                                                        <td>
                                                            <template v-if="shipping.constructor === Object && Object.keys(shipping).length != 0">
                                                                {{ shipping.shipInfo.shipCompany }}
                                                            </template>
                                                            <template v-else>
                                                                {{ labels[1338] }}-- label: N/A--
                                                            </template>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{ labels[1511] }}:-- label: Account Number --</td>
                                                        <td>
                                                            <template v-if="shipping.constructor === Object && Object.keys(shipping).length != 0">
                                                                {{ shipping.shipInfo.accountNumber }}
                                                            </template>
                                                            <template v-else>
                                                                {{ labels[1338] }}-- label: N/A--
                                                            </template>
                                                        </td>
                                                        <td>
                                                            <router-link rel="nofollow" class="edit" :to="{name: 'Ship Method'}">
                                                                {{ labels[1091] }}-- Edit --
                                                            </router-link>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <tr v-if="shipping.type == 'chargeShipping'">
                                                    <td>
                                                        {{ labels[1508] }}-- label: Type: --
                                                    </td>
                                                    <td>
                                                        {{ labels[1474] }}-- label: Prepay &amp; Charge --
                                                    </td>
                                                    <td>
                                                        <router-link rel="nofollow" class="edit" :to="{name: 'Ship Method'}">
                                                            {{ labels[1091] }}-- Edit --
                                                        </router-link>
                                                    </td>
                                                </tr>
                                                <tr v-if="shipping.type == 'pickUp'">
                                                    <td>
                                                        {{ labels[1508] }}-- label: Type: --
                                                    </td>
                                                    <td>
                                                        {{ labels[1475] }}-- label: Self-pickup --
                                                    </td>
                                                    <td>
                                                        <router-link rel="nofollow" class="edit" :to="{name: 'Ship Method'}">
                                                            {{ labels[1091] }}-- Edit --
                                                        </router-link>
                                                    </td>
                                                </tr> -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- /row -->
            <hr />
            <cart-footer>
              <template v-slot:left><div v-html="labels[1512]"></div></template>
              <template v-slot:center>
                <table id="review-final">
                  <tr><td>&nbsp;</td></tr>
                  <tr><td>&nbsp;</td></tr>
                  <tr><td>&nbsp;</td></tr>
                  <tr>
                    <td>
                      <div id="order-market">
                        <!--US is set to SHOW >>>  _set[session.cart.compInstanceId].marketSelector == 'Show'-->
                        {{ labels[1098] }}
                        <!-- This Order's Application: -->
                        <br />
                        <em v-if="market && market.solution != ''">
                          {{ market.solution }}
                        </em>
                        <em v-else class="red">
                          {{ labels[1099] }}
                          <!-- Not Selected -->
                        </em>
                        &nbsp;
                        <a
                          href=""
                          id="pick-application-vue"
                          @click.prevent="pickApplication"
                          class="small"
                        >
                          {{ labels[1100] }}
                        </a>
                        <!-- change -->
                      </div>
                    </td>
                  </tr>
                  <tr><td>&nbsp;</td></tr>
                  <tr><td>&nbsp;</td></tr>
                  <tr>
                    <td>
                      <div id="terms-conds">
                        <span v-html="labels[1102]"></span>
                        <!-- By submitting this order, you agree to the Campbell Scientific <a href="/terms" target="_blank" class="edit">Terms and Conditions</a>. -->
                        <br class="visible-xs" />
                      </div>
                    </td>
                  </tr>
                </table>
              </template>
              <template v-slot:right>
                <div class="priceDisplayBox">
                  <Checkout-Total-Box />
                </div>
                <button
                  id="submit-order-vue"
                  @click.prevent="submitOrder"
                  href=""
                  :disabled="isProcessingOrder"
                  class="btn btn-primary btn-block"
                >
                  {{ labels[1097] }}
                  <strong>&rsaquo;</strong>
                  <!-- Submit Order -->
                </button>
              </template>
            </cart-footer>
          </div>
          <!-- /col -->
        </div>
        <!-- /row -->
      </div>
      <!-- /container-->
    </div>
    <!-- /container-fluid -->

    <modal id="app-picker-vue" v-if="showAppPickerModal" @close="closeAppPickerModal">
      <template v-slot:header>
        <span class="ui-dialog-title">
          {{ labels[1101] }}
          <!-- Change Application -->
        </span>
      </template>

      <template v-slot:body>
        <div>
          <form id="order-app-form-vue" name="order-app-form" @submit.prevent="submitOrderApp">
            <div>
              <label>
                {{ labels[1103] }}
                <!-- Select the area/application that the products you are ordering will be used in: -->
              </label>
              <solution-selector @solution-selected="setSolution($event)"></solution-selector>
            </div>
          </form>
        </div>
      </template>

      <template v-slot:footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <div class="ui-dialog-buttonset">
            <button @click.prevent="closeAppPickerModal">{{ labels[1030] }}</button>
            <!-- Cancel -->
            <button @click.prevent="saveSelectedSolution()">{{ labels[1033] }}</button>
            <!-- Submit -->
          </div>
        </div>
      </template>
    </modal>

    <modal id="processing-order-vue" v-if="isProcessingOrder" size="xs">
      <template v-slot:header>
        <span v-if="hasResponse">{{ orderProcessed.msgTitle }}</span>
        <span v-else>
          {{ labels[1105] }}
          <!-- Processing Order -->
        </span>
        <!-- &nbsp; added for header height-->
        &nbsp;
      </template>

      <template v-slot:body>
        <div v-if="!hasResponse" id="processing-order-data-vue" class="center">
          <img src="/layouts/main/styles/images/spinner.gif" />
        </div>
        <div v-else>
          <p>{{ orderProcessed.msg }}</p>
        </div>
      </template>

      <template v-slot:footer>
        <div v-if="hasResponse" class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <div class="ui-dialog-buttonset">
            <button @click.prevent="closeProcessingOrderModal">{{ labels[1031] }}</button>
            <!-- Close -->
          </div>
        </div>
        <span></span>
      </template>
    </modal>
  </div>
</template>

<script>
  import { ref, computed } from '@vue/composition-api'
  import router from '../router'
  import axios from 'axios'
  import useAlerts from '../../shared/composables/useAlerts'
  import useCMS from '../../shared/composables/useCMS'
  import Modal from '../../shared/components/Modal.vue'
  import useUtils from '../../shared/composables/useUtils'
  import CartFooter from '../components/CartFooter'
  import useCheckout from '../composables/useCheckout'
  import useShipping from '../composables/useShipping'
  import useBilling from '../composables/useBilling'
  import CheckoutReviewItem from '../components/CheckoutReviewItem.vue'
  import CheckoutTotalBox from '../components/CheckoutTotalBox.vue'
  import SolutionSelector from '../../solution-selector/components/SolutionSelector'

  export default {
    name: 'CheckoutReview',
    components: {
      CheckoutReviewItem,
      CheckoutTotalBox,
      Modal,
      SolutionSelector,
      CartFooter,
    },
    setup() {
      const { labels, pageURLs } = useCMS()
      const { addAlert } = useAlerts()
      const { breakCharsToBr } = useUtils()
      const { addresses, info: checkoutInfo, itemList, pricing } = useCheckout()
      const { shipMethod, methods, shippingSet, shipNotes } = useShipping()
      const { method: billingMethod, card: billingCard, po: billingPo } = useBilling()
      const {
        showAppPickerModal,
        pickApplication,
        closeAppPickerModal,
        submitOrderApp,
        setSolution,
        saveSelectedSolution,
      } = useAppPicker()
      const {
        isProcessingOrder,
        submitOrder,
        closeProcessingOrderModal,
        hasResponse,
        orderProcessed,
      } = useSubmitOrder()

      const openPOPDF = () => {
        const shipInfo = {
          shipMethod: shipMethod.value,
          methods: methods.value,
          shippingSet: shippingSet.value,
          shipNotes: shipNotes.value,
        }

        const params = new URLSearchParams({
          addresses: JSON.stringify(addresses.value),
          po: JSON.stringify(billingPo.value),
          shipInfo: JSON.stringify(shipInfo),
          pricing: JSON.stringify(pricing.value),
        })

        axios
          .post('/actions/checkout.cfc?method=generatePoPdf', params, {
            responseType: 'arraybuffer',
          })
          .then(function(response) {
            var pdfFile = new Blob([response.data], { type: 'application/pdf' })
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              //IE
              window.navigator.msSaveOrOpenBlob(pdfFile)
              return
            } else {
              //Other browsers
              const fileURL = URL.createObjectURL(pdfFile)
              window.open(fileURL)
            }
          })
          .catch((error) => {
            addAlert('An error occurred generating the PO PDF.', 'alert-danger', 7000)
            console.log(error)
          })
      }

      //we dont use itemList.value.reverse() as that would mutate the itemList array
      const itemListReversed = computed(() => [...itemList.value].reverse())

      return {
        labels,
        pageURLs,
        breakCharsToBr,
        pickApplication,
        closeAppPickerModal,
        showAppPickerModal,
        submitOrderApp,
        orderProcessed,
        isProcessingOrder,
        submitOrder,
        closeProcessingOrderModal,
        addresses,
        itemListReversed,
        billingMethod,
        billingCard,
        billingPo,
        shipMethod,
        hasResponse,
        isQuote: computed(() => checkoutInfo.value.isQuote),
        setSolution,
        saveSelectedSolution,
        market: computed(() => checkoutInfo.value.market),
        openPOPDF,
      }
    },
  }

  function useAppPicker() {
    const showAppPickerModal = ref(false)
    const selectedSolution = ref({})
    const { info: checkoutInfo } = useCheckout()

    const pickApplication = () => {
      showAppPickerModal.value = true
    }

    const closeAppPickerModal = () => {
      showAppPickerModal.value = false
    }

    const setSolution = (solution) => {
      selectedSolution.value = solution
    }

    const saveSelectedSolution = () => {
      showAppPickerModal.value = false
      checkoutInfo.value.market = {
        id: selectedSolution.value.SOLUTIONID,
        solution: selectedSolution.value.SOLUTION_TITLE,
        market: selectedSolution.value.MARKET_NAME,
      }
    }

    return {
      showAppPickerModal,
      pickApplication,
      closeAppPickerModal,
      setSolution,
      saveSelectedSolution,
    }
  }

  function useSubmitOrder() {
    const {
      submit: submitCheckout,
      orderProcessed,
      clearOrderProcessed,
      orderComplete,
    } = useCheckout()

    clearOrderProcessed()
    const hasResponse = computed(
      () =>
        Object.keys(orderProcessed.value).length > 0 && orderProcessed.value.constructor === Object
    )
    const isProcessingOrder = ref(false)

    const submitOrder = () => {
      if (!isProcessingOrder.value) {
        isProcessingOrder.value = true

        submitCheckout()
          .then((resp) => {
            orderProcessed.value = resp.data
            orderProcessed.value.msgTitle = ''
            if (orderProcessed.value.status == 200) {
              orderProcessed.value.msgTitle = 'Order Success'
              orderComplete()
              router.push('Complete')
            } else {
              orderProcessed.value.msgTitle = 'Order Failed'
              //todo: the orderProcessed.msg may not be the most helpful thing to display to the customer
            }
          })
          .catch((error) => {
            closeProcessingOrderModal()
            orderProcessed.value.msgTitle = 'Order Failed'
            orderProcessed.value.msg = 'An error occurred when processing your order.'
            console.log(error)
          })
      }
    }

    const closeProcessingOrderModal = () => {
      isProcessingOrder.value = false
      clearOrderProcessed()
    }

    return {
      isProcessingOrder,
      submitOrder,
      closeProcessingOrderModal,
      hasResponse,
      orderProcessed,
    }
  }
</script>
